export enum ActionMode {
    'BATCH' = 'batch',
    'BULK' = 'bulk'
}

export interface SelectionState {
    selectAll: boolean;
    deselectAll: boolean;
    actionMode: ActionMode;
}
